import React from "react";
import { API_ENDPOINTS } from "@/src/config/api.js";

const HomeImage = () => {
    let [responseData, setResponseData] = React.useState(null);
    const fetchData = React.useCallback(() => {
        fetch(API_ENDPOINTS.home.random)
            .then(response => response.json())
            .then((response) => {
                setResponseData(response[0]);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    React.useEffect(() => {
        fetchData();
    }, []);
    if (responseData) {
        return (
            <img src={`//www.dreamchimney.com/mainpage/covers/${responseData} `} alt="Dream Chimney" className="img-responsive dc-home-image" />
        );
    }
    else {
        return <div />;
    }
};

export default HomeImage;
